import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CodigoProductoEnum } from 'src/app/global/enums/codigo-producto.enum';
import { Paso3 } from 'src/app/global/interfaces/paso-3';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { PayProcessServiceVM } from 'src/app/view-model/services/pay-process.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { RutFormatterService } from 'src/app/view-model/services/rut-formatter.service';
import { DialogServiceProvider } from 'src/app/view-model/providers/services/dialog/dialog.provider';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';

interface dataView {
  run: string;
  name: string;
  email: string;
  phone: string;
}

@Component({
  selector: 'app-resumen-compra',
  templateUrl: './resumen-compra.component.html',
  styleUrls: ['./resumen-compra.component.scss'],
  providers: [DialogServiceProvider]
})
export class ResumenCompraComponent implements OnInit, AfterViewInit {

  public data: dataView;
  products$ = this.carroService.products$;
  show = false;
  private subscription: Subscription;
  public loadingButton: boolean;
  public loadingButtonValida: boolean;
  private ERROR_PAGE_URL = '/error-pago';
  public isWix:boolean = false;
  public mensaje = '';
  public loading: boolean;
  public enableDiscountBox: boolean = true;
  public pagoPendiente: boolean = false;
  public flujoEjecutivo: boolean = false;
  showModal: boolean = true;
  public modalEjecutivo : boolean = false;
  public pagoBlocked : boolean = false;

  constructor(
    private tagManagerService: TagManagerService,
    private localStorageService: LocalStorageService,
    private carroService: CarroComprasService,
    private router: Router,
    private payProcessServiceVM: PayProcessServiceVM,
    private productoService: vmProductosService,
    private rutFormatter: RutFormatterService,
    private dialogService: DialogService,
  ) {
  }

  ngOnInit() {
    const eventoEcommers = GoogleTagManager.eventPageView().detallesContratacionConfirma();
    /*  eventoEcommers.codigoDescuento = this.carroService.getCodigoDescuento(); */
    this.tagManagerService.logEvent(eventoEcommers);
    this.tagManagerService.logResumenPago(this.localStorageService.getPaso3(), this.localStorageService.getPaso1().currentIsPersonaNatural);
    this.checkSoicosMark();
    this.loading = true;
    const fnSuccess = async (resp) => {
      const dv = this.rutFormatter.getDv(Number(resp.data.rut));
      this.data = {
        run: this.rutFormatter.format(resp.data.rut + '-' + dv).toUpperCase(),
        name: resp.data.nombre,
        email: resp.data.email,
        phone: '+56 ' + resp.data.telefono
      };
      this.flujoEjecutivo = resp.data.flujoEjecutivo
      this.loading = false;
    };
    const fnFailure = (error) => {
      this.loading = false;
    };

    this.productoService.resumenPago().subscribe(fnSuccess, fnFailure);

    this.carroService.changePaso('P_3');
    this.getCarrito();
  }

  ngAfterViewInit() {
    this.subscription = this.carroService.mostrarCarro$.subscribe((show) => {
      this.show = show;
    });
  }

  private checkSoicosMark() {
    if (this.localStorageService.getPaso3().soicos != undefined) {
      let currentProduct = this.carroService.getCurrentProduct();
      let step3Data: Paso3 = this.localStorageService.getPaso3();
      step3Data.soicos = {
        isSoicos: step3Data.soicos.isSoicos,
        isVenta: currentProduct.etiquetaVenta == true,
        total: currentProduct.amount
      }
      this.localStorageService.setPaso3(step3Data);
    }
  }

  private async getCarrito() {
    await this.productoService.cargaSeleccionActualEnCarro().toPromise();
    if (this.productoService.productos[0].codigoProducto === CodigoProductoEnum.CREACION_SITIO_ALIANZA_WIX) {
      this.mensaje = 'contratación pago anual WIX + Webpay PLUS';
    } else {
      this.mensaje = 'compra de producto ' + this.productoService.productos[0].title;
    }
  }

  public back() {
    localStorage.setItem('spinner', 'resumenPago');
    this.router.navigate(['/']);
  }

  public async goPay() {
    this.loadingButton = true;
    this.tagManagerService.logPagarOrden();
    try {
      const response = await this.payProcessServiceVM.payProcess(true);
      await this.wait(3500);
      if(response.ejecutivo && response.correoOk){
        this.modalEjecutivo = true;
      }
      this.loadingButton = false;
    } catch (error) {
      console.error(error);
    }
    // this.router.navigate([this.ERROR_PAGE_URL])
  }
  modalCuponHide() {
    this.showModal = false;
  } 
  modalMsjEjecutivoHide() {
    this.modalEjecutivo = false;
    this.pagoBlocked = true;
    window.top.close();
  }
  /**
   * Espera 3 segundo antes de realizar la habilitacion del boton de pago (dando tiempo para la redireccion)
   * @param timeout Tiempo de espera
   * @returns
   */
  private wait(timeout) {
    return new Promise(resolve => {
      setTimeout(resolve, timeout);
    });
  }
}
